import { useSystemEmailPreview } from "../../../hooks/admin/useSystemEmails";
import { SystemEmailPreviewContent } from "./SystemEmailPreviewContent";

export function SystemEmailPreviewLoader({
  emailTypeId,
}: {
  emailTypeId: string | null;
}) {
  const preview = useSystemEmailPreview(emailTypeId);
  return (
    <SystemEmailPreviewContent
      error={preview.error}
      loading={preview.isLoading}
      preview={preview.data}
    />
  );
}
